import React from 'react';
import PropTypes from "prop-types";

import {COUNTRIES} from "../../constants/countries";
import {STATES} from "../../constants/states";

function DistrictDropdownItem({item}) {
    let location = [];
    if (item.state) {
        if (item.country && STATES.hasOwnProperty(item.country) && STATES[item.country].hasOwnProperty(item.state)) {
            location.push(STATES[item.country][item.state]);
        } else {
            location.push(item.state);
        }
    }
    if (item.country) {
        if (COUNTRIES.hasOwnProperty(item.country)) {
            location.push(COUNTRIES[item.country]);
        } else {
            location.push(item.country);
        }
    }

    return (
        <div>
            <div className="autocomplete-dropdown-menu-item-title">{item.name}</div>
            <div className="autocomplete-dropdown-menu-item-second">{location.join(', ')}</div>
        </div>
    );
}

DistrictDropdownItem.propTypes = {
    item: PropTypes.shape({
        name: PropTypes.string.isRequired,
        measure: PropTypes.string
    }).isRequired
};

export default DistrictDropdownItem;
